export function UnitTransactionsCtrl (
  $scope,
  $state,
  $translate,
  workshopAPI
) {
  $scope.transactions = [];

  $scope.tableSettings = {
    columns: [
      {
        field   : 'transaction_time',
        header  : {
          text: $translate.instant('GENERAL_SPACE.FIELD.DATE')
        },
        pipe    : 'date',
        pipeArgs: 'MMM d, yyyy h:mm a'
      },
      {
        field : 'username',
        header: {
          text: $translate.instant('COMPANY_SPACE.USERS.USER')
        },
      },
      {
        field : 'transaction_note',
        header: {
          text: $translate.instant('JS_SPACE.COLUMNS.TRANSACTION')
        },
      },
      {
        field : 'transaction_amount',
        header: {
          text: $translate.instant('JS_SPACE.COLUMNS.AMOUNT')
        },
        pipe  : 'globalCurrency'
      }
    ],
    empty: {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_TRANSACTIONS')
    },
    pagination: {
      enabled   : true,
      pageSize  : 5,
      pageSizes : [ 5, 10 ],
      queryCount: () => workshopAPI.get('/dealership_transaction_logs/count_for_vehicle', $scope.unit.id)
    },
    rows: {
      highlight: {
        enabled: true
      },
    },
    sorting: {
      enabled: false
    },
  };

  $scope.getTransactions = ( params ) => {
    return workshopAPI.get('/dealership_transaction_logs/index_for_vehicle', [
      $scope.unit.id,
      params.offset,
      params.pageSize
    ]).then(function (transactions) {
      $scope.transactions = transactions;
      return transactions;
    });
  };

  $scope.onRowDoubleClick = function (event) {
    if (!event.row.is_void && event.row.transaction_type !== 'import') {
      if (event.row.transaction_type === 'acquisition') {
        $state.go('app.vendor-invoice', {
          vendor_id: event.row.associated_reference1,
          id       : event.row.linked_id
        });
      }
      else {
        $state.go('app.invoice', {
          customer_id: event.row.associated_reference1,
          vehicle_id : event.row.associated_reference2,
          id         : event.row.linked_id
        });
      }
    }
  };

  $scope.getTransactions({offset: 0, pageSize: 5});
}